import { Box, Button, TextField, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import AmountUnits from '../AmountUnits'

const FiltersNotificationsMonitoring = ({
  filters,
  control,
  optionLevels,
  optionsClientTypes,
  optionsUnits,
  optionsFileStatus,
  typeFilter,
  activeFilters,
  handleAddLevel,
  handleRemoveCriterion,
}) => {
  const { t } = useTranslation(['common'])

  if (!filters || !filters.length || !typeFilter) return null

  // Usar el primer filtro del array (que es el filtro actual)
  const currentFilter = filters[0]
  if (!currentFilter) return null

  // Asegurar que criteria existe como array
  const criteria = currentFilter.criteria || []

  const used = criteria.map((c) => {
    if (typeFilter === 'RISK_LEVEL') return c.riskLevel
    if (typeFilter === 'CLIENT_TYPE') return c.clientType
    if (typeFilter === 'FILE_STATUS') return c.fileStatus
    return undefined
  })

  const missingLevels = () => {
    let options = []
    if (typeFilter === 'RISK_LEVEL') {
      options = optionLevels
    } else if (typeFilter === 'CLIENT_TYPE') {
      options = optionsClientTypes
    } else if (typeFilter === 'FILE_STATUS') {
      options = optionsFileStatus
    }
    return options.filter((opt) => !used.includes(opt.value))
  }

  return (
    <Box mb={4}>
      <Typography variant="subtitle2">{t(`common:${typeFilter}`)}</Typography>

      {criteria.map((_, criterionIndex) => (
        <Box key={criterionIndex} display="flex" alignItems="center" gap="1rem" mt={2}>
          <Controller
            name={`filters.0.criteria.${criterionIndex}.${activeFilters[typeFilter]}`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                type="text"
                size="small"
                sx={{
                  width: 150,
                  '& input': {
                    textTransform: 'uppercase',
                  },
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            )}
          />

          <Typography>{t('common:every')}</Typography>

          <AmountUnits
            amount={`filters.0.criteria.${criterionIndex}.amount`}
            unit={`filters.0.criteria.${criterionIndex}.unit`}
            control={control}
            optionsUnits={optionsUnits}
          />

          <Button
            onClick={() => handleRemoveCriterion(0, criterionIndex)}
            size="small"
            sx={{
              padding: '4px',
              border: 0,
              '&:hover': { border: 0, backgroundColor: 'transparent' },
            }}
          >
            <DeleteIcon />
          </Button>
        </Box>
      ))}

      <Box mt={2} display="flex" gap="1rem" flexWrap="wrap">
        {missingLevels().map((level) => (
          <Button
            key={level.value}
            variant="outlined"
            onClick={() => handleAddLevel(level.value, 0)}
            size="small"
            sx={{ padding: '10px' }}
          >
            {typeFilter === 'RISK_LEVEL'
              ? t(`common:${level.value}`)
              : typeFilter === 'FILE_STATUS'
              ? t(`common:${level.value}`)
              : String(level.value).toUpperCase()}
          </Button>
        ))}
      </Box>
    </Box>
  )
}

export default FiltersNotificationsMonitoring
